import React from "react";
import PropTypes from "prop-types";
// import TextField from '@material-ui/core/TextField';
import TextField from "@mui/material/TextField";
import { InputLabel, Paper, Tooltip } from "@mui/material";
import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded";
import axios from "axios";
import SiteList from "./Components/sitelist";
import DraggableDialog from "../CustomDialogs/DraggableDialog";
import { genURL } from "../../_getjson";

const styles = {
  textField: {
    fontFamily: "Customfont !important",
  },
};

export default function CustomSiteCodeInput(props) {
  const {
    label,
    id,
    defaultValue,
    helperText,
    inputType,
    tabIndex,
    placeholder,
    multiselect,
  } = props;

  const [state, setState] = React.useState({
    inputData: defaultValue,
    inputDataShow: "",
    inputNameData: "",
    openDialog: false,
    titleDialog: "เลือกสาขา",
    inputChangData: false,
  });

  React.useEffect(() => {
    console.log("defaultValue", defaultValue);
    checkData(defaultValue);
    return () => {};
  }, [defaultValue]);

  React.useEffect(() => {
    props.resData(state.inputData);
    return () => {};
  }, [state.inputData]);
  const handleChange = (event) => {
    // event.preventDefault();
    console.log("handleChange", event.target.value);
    setState((prevState) => ({
      ...prevState,
      inputData: event.target.value,
      inputDataShow: event.target.value,
      inputChangData: true,
    }));
  };
  const onBlur = (event) => {
    if (state.inputChangData === true) {
      checkData(state.inputData);
    } else {
      setState((prevState) => ({
        ...prevState,
        inputDataShow: state.inputNameData,
      }));
    }
  };
  const handleKeyDown = (event) => {
    try {
      if (event.key === "Enter") {
        checkData(state.inputData);
      }
      props.keyDown(event.key);
    } catch (error) {
      // console.log("handleKeyDown err", error);
    }

    // event.preventDefault();
    // try {
    //     //     if (event.key === "Enter") {
    //     props.keyDown(event.key)
    // }
    // catch (error) {
    //     console.log("handleKeyDown err", error);
    // }
  };

  const handleSearchClick = () => {
    // console.log("testxxxxx handleSearchClick");
    // setOpenDialog(true)

    setState((prevState) => ({
      ...prevState,
      openDialog: true,
    }));
  };

  const resultSiteData = async (e) => {
    let data = "";
    let nameData = "";
    for (let index = 0; index < e.length; index++) {
      data += e[index].code;
      data += index > -1 && index < e.length - 1 ? "," : "";

      nameData += e[index].name;
      nameData += index > -1 && index < e.length - 1 ? "," : "";
    }
    await setState((prevState) => ({
      ...prevState,
      inputData: data,
      inputDataShow: nameData,
      inputNameData: nameData,
      openDialog: false,
    }));

    // let data = ""
    // for (let index = 0; index < e.length; index++) {
    //     data += await e[index].code
    //     data += await index > -1 && index < e.length - 1 ? "," : "";
    // }
    // //await console.log(SiteCode);
    // await setInputData(data)
    // await setOpenDialog(false)
    // await props.resData({ siteCode: data })
  };

  const handleFocus = (event) => {
    event.preventDefault();
    setState((prevState) => ({
      ...prevState,
      inputDataShow: state.inputData,
    }));
  };

  const checkData = async (val) => {
    console.log("CheckData", val);

    let url = `CSSITE/Getsite?Code=` + val;
    // console.log("urlTest" + genURL(url));
    await axios.get(genURL(url)).then((e) => {
      console.log("res", e.data);
      if (e.data.length > 0) {
        setState((prevState) => ({
          ...prevState,
          inputDataShow: e.data[0].MYNAMETH,
          inputNameData: e.data[0].MYNAMETH,
          inputData: e.data[0].CODE,
          inputChangData: false,
        }));
        // console.log(e.data)
        // setNameInputData(e.data[0].DOCNAME);
      } else {
        setState((prevState) => ({
          ...prevState,
          inputDataShow: "",
          inputNameData: "",
          inputData: "",
          inputChangData: false,
        }));
      }
    });
  };

  return (
    <>
      <Paper
        elevation={0}
        component="div"
        sx={{
          pl: "5px",
          pt: "1px",
          m: "0px",
          display: "flex",
          alignItems: "center",
          backgroundColor: "#eee",
          border: "1px solid #ccc",
          verticalAlign: "middle",
        }}
      >
        <Tooltip title={label}>
          <InputLabel
            sx={{
              width: "140px",
              whiteSpace: "nowrap",
              fontSize: "16px",
              fontFamily: "Customfont !important",
              color: "black",
              verticalAlign: "middle",
            }}
          >
            {label}
          </InputLabel>
        </Tooltip>

        <TextField
          sx={{
            //     "& label.Mui-focused": {
            //         display: "none",
            //     },
            //     "& legend": {
            //         display: "none",
            //     },
            backgroundColor: "#fff",
            fontFamily: "Customfont",
            //     marginTop: "0px",
          }}
          hiddenLabel
          id={id}
          // defaultValue={defaultValue}
          onChange={handleChange}
          value={state.inputDataShow}
          helperText={helperText}
          variant="standard"
          size="small"
          type={inputType}
          fullWidth
          tabIndex={tabIndex}
          placeholder={placeholder}
          onBlur={(e) => onBlur(e)}
          onKeyDown={handleKeyDown}
          onFocus={handleFocus}
          inputProps={{
            style: { fontSize: "0.9rem", fontFamily: "Customfont" },
          }}
        />
        <ManageSearchRoundedIcon
          sx={{ cursor: "pointer" }}
          onClick={(_) => handleSearchClick()}
        />
      </Paper>

      <DraggableDialog
        open={state.openDialog}
        title={state.titleDialog}
        closeDialog={(e) =>
          setState((prevState) => ({
            ...prevState,
            openDialog: e,
          }))
        }
      >
        <SiteList
          resultData={(e) => resultSiteData(e)}
          multiselect={multiselect}
        />
      </DraggableDialog>
    </>
  );
}
CustomSiteCodeInput.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  defaultValue: PropTypes.string,
  helperText: PropTypes.string,
  inputType: PropTypes.oneOf([
    "button",
    "checkbox",
    "color",
    "date",
    "datetime-local",
    "email",
    "file",
    "hidden",
    "image",
    "month",
    "number",
    "email",
    "password",
    "radio",
    "range",
    "reset",
    "search",
    "submit",
    "tel",
    "text",
    "time-local",
    "url",
    "file",
    "week",
  ]),
  placeholder: PropTypes.string,
  tabIndex: PropTypes.string,
  multiselect: PropTypes.bool,
};
